import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../../theme';

export default function Footer() {
  const { p, d, fonts } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  function scrollToPrivacy() {
    if (location.pathname === '/') {
      document.getElementById('privacy-section')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => document.getElementById('privacy-section')?.scrollIntoView({ behavior: 'smooth' }), 300);
    }
  }

  return (
    <footer style={{
      padding: `28px ${d.pad}px`,
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 16,
      fontFamily: fonts.mono,
      fontSize: 11.5,
      color: p.textDim,
      letterSpacing: '.06em',
      borderTop: `1px solid ${p.border}`,
    }}>
      <span>usertags · archival index · est. 2024</span>
      <span style={{ display: 'flex', gap: 20 }}>
        <span style={{ cursor: 'pointer' }} onClick={scrollToPrivacy}>privacy</span>
        <span style={{ cursor: 'pointer' }} onClick={() => navigate('/guidelines')}>terms</span>
        <span style={{ cursor: 'pointer' }} onClick={() => window.open('https://github.com', '_blank')}>github</span>
        <span style={{ cursor: 'pointer' }} onClick={() => { window.location.href = 'mailto:contact@usertags.io'; }}>contact</span>
      </span>
      <span style={{ color: p.textFaint }}>© 2024–2026</span>
    </footer>
  );
}
